import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function quizsubcategoryListReducer(
  state = initialState.quizsubcategoryList,
  action
) {
  switch (action.type) {
    case types.LOADED_QUIZ_SUBCATEGORY_LIST_SUCCESS:
      return action.quizsubcategoryList;
    default:
      return state;
  }
}
